import "./AppearancePreview.scss"
import React from "react"
import get from "lodash/get"
import template from "../../../lib/template"
import { authStore } from "../../../app/stores"
import LayoutPreview from "./LayoutPreview"
import LauncherPreview from "./LauncherPreview"
import MessengerPreview from "./MessengerPreview"

const getFieldParsedValue = field => {
  return template(field.value, {
    name: get(authStore, "userData.user.profile.first_name", "John Doe"),
    contact: get(authStore, "userData.user.profile.email", "example@gmail.com"),
  })
}

const getFieldValue = field => field.value

const getColorStyle = ({ brand_color, text_color }) => {
  return {
    backgroundColor: brand_color && brand_color.value,
    color: text_color && text_color.value,
  }
}

const AppearancePreview = ({ display, ...fieldsData }) => {
  const colorStyle = getColorStyle(fieldsData)
  return (
    <div
      id="AppearancePreview"
      className="AppearancePreview"
      role="presentation">
      <LayoutPreview
        display={display}
        pos={getFieldValue(fieldsData.launcher_pos)}
        type={getFieldValue(fieldsData.launcher_type)}
        colorStyle={colorStyle}>
        {display === "launcher" ? (
          <LauncherPreview
            type={getFieldValue(fieldsData.launcher_type)}
            prompt={getFieldValue(fieldsData.launcher_prompt)}
            colorStyle={colorStyle}
          />
        ) : (
          <MessengerPreview
            prompt={getFieldValue(fieldsData.messenger_prompt)}
            entry={getFieldValue(fieldsData.messenger_entry)}
            hideLogo={getFieldValue(fieldsData.hide_logo)}
            hideTeamIcon={getFieldValue(fieldsData.hide_team_icon)}
            offlineGreeting={getFieldValue(fieldsData.offline_greeting)}
            contactEnabled={getFieldValue(fieldsData.contact_enabled)}
            contactDismissible={getFieldValue(fieldsData.contact_dismissible)}
            contactPrompt={getFieldValue(fieldsData.contact_prompt)}
            contactReply={getFieldParsedValue(fieldsData.contact_reply)}
            contactFieldLabel={getFieldValue(fieldsData.contact_field_label)}
            nameFieldLabel={getFieldValue(fieldsData.name_field_label)}
            colorStyle={colorStyle}
            display={display}
          />
        )}
      </LayoutPreview>
    </div>
  )
}

export default AppearancePreview



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/AppearancePreview.js